require("!!/usr/app/node_modules/script-loader/addScript.js")(require("!!/usr/app/node_modules/raw-loader/index.js!/usr/app/node_modules/photoswipe/dist/photoswipe.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/photoswipe/dist/photoswipe.js
// module id = 28
// module chunks = 2